var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fullscreen bg-grey-4"},[(_vm.invalidLink)?_c('div',{staticClass:"absolute-center"},[_c('div',{staticClass:"text-h3 text-grey-6"},[_vm._v("Sorry, this link is invalid.")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }